import script from "./orderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetail.vue?vue&type=script&setup=true&lang=js"

import "./orderDetail.vue?vue&type=style&index=0&id=fbc48498&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbc48498"]])

export default __exports__